import React from "react";

const QuizHeading = () => (
  <>
    <h1 className="quiz-title mb-2">
      Can you spot what's real and what's fake?
    </h1>
    <p className="quiz-subtitle mb-5">
      🔎 Practice your fact-checking skills by verifying claims with official
      sources like Parliament records and government websites. Always review
      full contexts, official votes, or policy announcements.
    </p>
  </>
);

export default QuizHeading;
